var _path, _path2, _rect, _rect2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteQuestion(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.63915 25.4751C0.577836 21.1334 -0.81622 12.7001 3.52544 6.63881C7.86711 0.577488 16.3004 -0.816568 22.3617 3.52509",
    stroke: "#979DA5",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63878 25.4751C12.7001 29.8168 21.1334 28.4227 25.475 22.3614C29.8167 16.3001 28.4226 7.86681 22.3613 3.52515",
    stroke: "#979DA5",
    strokeDasharray: "2 4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.8281,
    y: 18.2427,
    width: 10,
    height: 2,
    transform: "rotate(-135 16.8281 18.2427)",
    fill: "#B3261E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.75781,
    y: 16.8284,
    width: 10,
    height: 2,
    transform: "rotate(-45 9.75781 16.8284)",
    fill: "#B3261E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteQuestion);
export default __webpack_public_path__ + "static/media/deleteQuestion.dd732d2eb56e152a20f6db0ee1d3e10d.svg";
export { ForwardRef as ReactComponent };